<template>
  <div class="ParisLove">
      <p>Cooked with <img src="@/assets/heart.png" alt="love"> in #Paris</p>
  </div>
</template>

<script>
export default {
    name: "ParisLove"
}
</script>

<style scoped lang="scss">
.ParisLove{
    font-size:20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    max-width: 22em;
    
    position: relative;
    box-sizing: border-box;
    
    $border: 5px;
    padding: 10px 20px;
    background-color: white;
    border: solid 2px transparent; /* !importanté */
    border-radius: 15px;
    
    &:before {
        content: '';
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        z-index: -1;
        margin: -$border; /* !importanté */
        border-radius: inherit; /* !importanté */
        background: linear-gradient(to right, $purple, $pink);
    }
}
    
.ParisLove p {
    margin-bottom: 0;
}

.ParisLove img {
    width:23px;
    height: 23px;
}

</style>